import React from 'react';
 
const NotFound = () => (
  <h1>Ruta no encontrada</h1>
);

export default NotFound;
